import React, { useEffect, useState, useRef } from "react";
import Swal from "sweetalert2";
import { site } from "../config/api";

import {
  HiChevronLeft,
  HiChevronRight,
  HiOutlineClipboardDocumentList,
  HiOutlineMagnifyingGlassCircle,
  HiOutlineBanknotes,
  HiOutlineCalendarDays,
  HiOutlineDocumentText,
  HiOutlineAcademicCap,
  HiOutlinePresentationChartBar,
  HiOutlineBuildingLibrary,
  HiOutlineChartBarSquare,
  HiOutlinePencilSquare,
  HiOutlineHeart,
  HiOutlineBookOpen,
  HiOutlineMoon,
  HiOutlineUserGroup,
  HiOutlineBriefcase,
  HiOutlineBeaker,
} from "react-icons/hi2";
import "./Home.css";
import { academicYearLabel } from "../config/academicYear";

// Banner หน้าแรก (เฟส 1): ทับไฟล์ใน src/assets/2027/banner/ แล้วรีเฟรช
// banner001.png … banner004.png — ถ้าเปลี่ยนชื่อ/จำนวนสไลด์ แก้ import + heroSlides ด้านล่าง
import banner001 from "../assets/2027/banner/banner001.png";
import banner002 from "../assets/2027/banner/banner002.png";
import banner003 from "../assets/2027/banner/banner003.png";
import banner004 from "../assets/2027/banner/banner004.png";


const base = process.env.REACT_APP_BASENAME || "";

const heroSlides = [
  {
    src: banner001,
    alt: "รับสมัครนักศึกษา มหาวิทยาลัยราชภัฏกำแพงเพชร",
    href: `${base}/Register/1`,
  },
  {
    src: banner002,
    alt: "รับสมัครนักศึกษาภาคปกติ",
    href: `${base}/Register/1`,
  },
  {
    src: banner003,
    alt: "รับสมัครนักศึกษากศ.บป.",
    href: `${base}/Register/1`,
  },
  {
    src: banner004,
    alt: "เปิดรับสมัครนักศึกษา",
    href: `${base}/Register/2`,
  },
];

const registerTypes = [
  {
    href: `${base}/Register/1`,
    eyebrow: "รับสมัครนักศึกษา",
    title: "ภาคปกติ (จันทร์ - ศุกร์)",
    level: "ระดับปริญญาตรี",
    details: [],
    cta: "สมัครเรียน",
    Icon: HiOutlineBookOpen,
    tone: "rose",
  },
  {
    href: `${base}/Register/2`,
    eyebrow: "รับสมัครนักศึกษา",
    title: "ภาค กศ.บป. (เสาร์ - อาทิตย์)",
    level: "ระดับปริญญาตรี",
    details: [],
    cta: "สมัครเรียน",
    Icon: HiOutlineMoon,
    tone: "navy",
  },
  {
    href: `${base}/select-bundit`,
    eyebrow: "รับสมัครนักศึกษา",
    title: "ระดับบัณฑิตศึกษา",
    level: null,
    details: ["ระดับปริญญาโท", "ระดับปริญญาเอก"],
    cta: "สมัครเรียน",
    Icon: HiOutlineUserGroup,
    tone: "amber",
  },
  {
    href: `${base}/Register/5`,
    eyebrow: "รับสมัครนักศึกษา",
    title: "หลักสูตรประกาศนียบัตรบัณฑิต",
    level: "สาขาวิชาชีพครู",
    details: [],
    cta: "สมัครเรียน",
    Icon: HiOutlineBriefcase,
    tone: "sand",
  },
  {
    href: `${base}/Register/0`,
    eyebrow: "รับสมัครนักศึกษา",
    title: "หลักสูตรประกาศนียบัตรบัณฑิต",
    level: "สาขาผู้ช่วยพยาบาล",
    details: [],
    cta: "สมัครเรียน",
    Icon: HiOutlineBeaker,
    tone: "mint",
    wide: true,
  },
];

/** tone = สีประจำปุ่ม (ดู .home-service-item--* ใน Home.css) */
const services = [
  {
    href: `${base}/Procedureregister`,
    label: "ขั้นตอนการสมัคร",
    desc: "ดูขั้นตอนและเอกสารที่ต้องใช้",
    Icon: HiOutlineClipboardDocumentList,
    tone: "green",
  },
  {
    href: `${base}/Checkregister/2`,
    label: "ตรวจสอบสถานะ",
    desc: "ติดตามผลการสมัครของคุณ",
    Icon: HiOutlineMagnifyingGlassCircle,
    tone: "blue",
  },
  {
    href: `${base}/Tuitionfee`,
    label: "อัตราค่าธรรมเนียม",
    desc: "ดูค่าธรรมเนียมการศึกษา",
    Icon: HiOutlineBanknotes,
    tone: "amber",
  },
  {
    href: `${base}/Calendars`,
    label: "ปฏิทินการรับสมัคร",
    desc: "วันเปิด-ปิดรับสมัครแต่ละรอบ",
    Icon: HiOutlineCalendarDays,
    tone: "violet",
  },
  {
    href: `${base}/Checkpresent`,
    label: "กรอกข้อมูลรายงานตัว",
    desc: "รายงานตัวออนไลน์สำหรับผู้มีสิทธิ์",
    Icon: HiOutlineDocumentText,
    tone: "rose",
  },
  {
    href: `${base}/Scholarship`,
    label: "ขั้นตอนการกู้ยืม (กยศ.)",
    desc: "ข้อมูลทุนและการกู้ยืมเพื่อการศึกษา",
    Icon: HiOutlineAcademicCap,
    tone: "orange",
  },
];

const staffLinks = [
  {
    href: site + "/admission-teacher/login",
    label: "กรอกใบสมัคร สำหรับครูแนะแนว",
    desc: "ระบบสำหรับครูแนะแนว",
    Icon: HiOutlinePresentationChartBar,
    tone: "blue",
  },
  {
    href: site + "/admission-faculty/login",
    label: "กรอกใบสมัคร สำหรับคณะ",
    desc: "ระบบสำหรับคณะ",
    Icon: HiOutlineBuildingLibrary,
    tone: "green",
  },
  {
    href: site + "/administrator-system/",
    label: "รายงานจำนวนผู้สมัคร",
    desc: "ระบบรายงานและผู้ดูแล",
    Icon: HiOutlineChartBarSquare,
    tone: "violet",
  },
  {
    href: site + "/onlinescore/#/",
    label: "กรอกคะแนนสัมภาษณ์ (เฉพาะกรรมการ)",
    desc: "ระบบคะแนนออนไลน์",
    Icon: HiOutlinePencilSquare,
    tone: "amber",
  },
  {
    href: site + "/nurse_interviwe2022/",
    label: "กรอกคะแนนสัมภาษณ์ (เฉพาะพยาบาลศาสตร์)",
    desc: "ระบบสัมภาษณ์พยาบาลศาสตร์",
    Icon: HiOutlineHeart,
    tone: "rose",
  },
];

function Home_newlastbee() {
  const [slide, setSlide] = useState(0);
  const timerRef = useRef(null);
  const total = heroSlides.length;

  const goTo = (index) => {
    setSlide((index + total) % total);
  };

  const next = () => goTo(slide + 1);
  const prev = () => goTo(slide - 1);

  useEffect(() => {
    timerRef.current = setInterval(() => {
      setSlide((s) => (s + 1) % total);
    }, 5000);
    return () => clearInterval(timerRef.current);
  }, [total]);

  const pauseAutoplay = () => clearInterval(timerRef.current);
  const resumeAutoplay = () => {
    clearInterval(timerRef.current);
    timerRef.current = setInterval(() => {
      setSlide((s) => (s + 1) % total);
    }, 5000);
  };

  useEffect(() => {
    localStorage.clear();
    const prevBg = document.body.style.background;
    document.body.style.background = "#f3f7f4";

    let [day, month, year] = ["25", "04", "2025"];
    let [days, months, years] = ["22", "04", "2025"];
    if (parseInt(year, 10) > 2400) {
      year = (parseInt(year, 10) - 543).toString();
    }
    const startdate = new Date(`${month}/${day}/${year} 23:59`);
    const enddate = new Date(`${months}/${days}/${years} 23:59`);
    const datenow = new Date();

    if (startdate <= datenow && datenow <= enddate) {
      Swal.fire({
        html: "<div style='font-size:24px;' >  <div style='font-size:22;color:#0077b6;font-weight:700;'>ประกาศรายชื่อผู้มีสิทธิ์สอบสัมภาษณ์กศ.บป. </div> <div style='font-size:22;color:#0077b6;font-weight:700;'>วันที่ 26 เม.ย. 68 เวลา 18.00 น.</div></div>",
        confirmButtonText: "ดูผล",
        showConfirmButton: true,
        showCloseButton: true,
        cancelButtonColor: "green",
        confirmButtonColor: "#0d5c45",
      }).then((res) => {
        if (res.isConfirmed === true) {
          window.location.href = site + "/admission/Checkregister/2";
        }
      });
    }

    return () => {
      document.body.style.background = prevBg;
    };
  }, []);

  return (
    <div className="home-page">
      <header className="home-hero">
        <div className="home-inner home-hero__intro">
          <div className="home-brand">
            <p className="home-brand__uni">มหาวิทยาลัยราชภัฏกำแพงเพชร</p>
            <h1 className="home-brand__title">ระบบรับสมัครนักศึกษา</h1>
            <p className="home-brand__lead">
              สมัครออนไลน์ ติดตามสถานะ และดูข้อมูลการรับสมัครได้ครบในที่เดียว
            </p>
            <p className="home-brand__year">{academicYearLabel()}</p>
          </div>
          <div className="home-cta">
            <a className="home-btn home-btn--primary" href={`${base}/Register/1`}>
              <HiOutlineAcademicCap size={18} aria-hidden />
              สมัครเรียน
            </a>
            <a
              className="home-btn home-btn--soft"
              href={`${base}/Checkregister/2`}
            >
              <HiOutlineMagnifyingGlassCircle size={18} aria-hidden />
              ตรวจสอบสถานะ
            </a>
          </div>
        </div>

        <div
          className="home-carousel"
          onMouseEnter={pauseAutoplay}
          onMouseLeave={resumeAutoplay}
        >
          <div
            className="home-carousel__track"
            style={{ transform: `translateX(-${slide * 100}%)` }}
          >
            {heroSlides.map((item) => (
              <a
                key={item.src}
                className="home-carousel__slide"
                href={item.href}
              >
                {item.srcMobile ? (
                  <>
                    <img
                      src={item.src}
                      alt={item.alt}
                      className="d-none d-md-block"
                    />
                    <img
                      src={item.srcMobile}
                      alt={item.alt}
                      className="d-md-none d-block"
                    />
                  </>
                ) : (
                  <img src={item.src} alt={item.alt} />
                )}
              </a>
            ))}
          </div>

          <button
            type="button"
            className="home-carousel__nav home-carousel__nav--prev"
            aria-label="สไลด์ก่อนหน้า"
            onClick={prev}
          >
            <HiChevronLeft />
          </button>
          <button
            type="button"
            className="home-carousel__nav home-carousel__nav--next"
            aria-label="สไลด์ถัดไป"
            onClick={next}
          >
            <HiChevronRight />
          </button>

          <div
            className="home-carousel__dots"
            role="tablist"
            aria-label="สไลด์แบนเนอร์"
          >
            {heroSlides.map((item, i) => (
              <button
                key={item.src}
                type="button"
                role="tab"
                aria-selected={i === slide}
                aria-label={`สไลด์ที่ ${i + 1}`}
                className={`home-carousel__dot${i === slide ? " is-active" : ""}`}
                onClick={() => goTo(i)}
              />
            ))}
          </div>
        </div>
      </header>

      <section className="home-section home-section--register">
        <div className="home-inner">
          <h2 className="home-section__label">
            เลือกประเภทการสมัคร
            <span>เลือกหลักสูตรที่ต้องการ แล้วกดสมัครเรียน</span>
          </h2>
          <div className="home-register-list">
            {registerTypes.map(
              (
                { href, eyebrow, title, level, details, cta, Icon, tone, wide },
                index
              ) => (
                <a
                  key={href}
                  href={href}
                  style={{ "--stagger": index }}
                  className={`home-register-item home-register-item--${tone}${
                    wide ? " home-register-item--wide" : ""
                  }`}
                >
                  <span className="home-register-item__icon" aria-hidden="true">
                    <Icon />
                  </span>
                  <span className="home-register-item__body">
                    <span className="home-register-item__eyebrow">{eyebrow}</span>
                    <strong className="home-register-item__title">{title}</strong>
                    {level ? (
                      <span className="home-register-item__level">{level}</span>
                    ) : null}
                    {details?.length ? (
                      <ul className="home-register-item__details">
                        {details.map((d) => (
                          <li key={d}>{d}</li>
                        ))}
                      </ul>
                    ) : null}
                  </span>
                  <span className="home-register-item__cta">{cta}</span>
                </a>
              )
            )}
          </div>
        </div>
      </section>

      <section className="home-section home-section--services">
        <div className="home-inner">
          <h2 className="home-section__label">
            บริการสำหรับผู้สมัคร
            <span>ขั้นตอนสมัคร · สถานะ · ค่าเทอม · ปฏิทิน</span>
          </h2>
          <div className="home-service-list">
            {services.map(({ href, label, desc, Icon, tone }, index) => (
              <a
                key={href}
                href={href}
                style={{ "--stagger": index }}
                className={`home-service-item home-service-item--${tone}`}
              >
                <span className="home-service-item__icon" aria-hidden="true">
                  <Icon />
                </span>
                <span className="home-service-item__text">
                  <strong>{label}</strong>
                  <em>{desc}</em>
                </span>
              </a>
            ))}
          </div>
        </div>
      </section>

      <section className="home-section home-section--staff">
        <div className="home-inner">
          <h2 className="home-section__label">
            สำหรับบุคลากร
            <span>ระบบภายในของมหาวิทยาลัย</span>
          </h2>
          <div className="home-service-list home-service-list--staff">
            {staffLinks.map(({ href, label, desc, Icon, tone }, index) => (
              <a
                key={href}
                href={href}
                target="_blank"
                rel="noreferrer"
                style={{ "--stagger": index }}
                className={`home-service-item home-service-item--${tone}`}
              >
                <span className="home-service-item__icon" aria-hidden="true">
                  <Icon />
                </span>
                <span className="home-service-item__text">
                  <strong>{label}</strong>
                  <em>{desc}</em>
                </span>
              </a>
            ))}
          </div>
        </div>
      </section>

      <footer className="home-contact">
        <div className="home-inner">
          <h2>ติดต่อสอบถามเพิ่มเติม</h2>
          <ul className="home-contact__list">
            <li>
              <span className="home-contact__role">ภาคปกติ - ภาค กศ.บป.</span>
              <span className="home-contact__links">
                <a href="tel:055706547">(055) 706 547</a>
                <a
                  href="https://www.facebook.com/kpru.register"
                  target="_blank"
                  rel="noreferrer"
                >
                  Facebook
                </a>
              </span>
            </li>
            <li>
              <span className="home-contact__role">ปริญญาโท - ปริญญาเอก</span>
              <span className="home-contact__links">
                <a href="tel:055706555">(055) 706 555 ต่อ 1780, 1671</a>
                <a
                  href="https://www.facebook.com/kprugrads/"
                  target="_blank"
                  rel="noreferrer"
                >
                  Facebook
                </a>
              </span>
            </li>
            <li>
              <span className="home-contact__role">
                ประกาศนียบัตรบัณฑิต สาขาวิชาชีพครู
              </span>
              <span className="home-contact__links">
                <a href="tel:055706555">(055) 706 555 ต่อ 2010</a>
                <a
                  href="https://www.facebook.com/edukpru/"
                  target="_blank"
                  rel="noreferrer"
                >
                  Facebook
                </a>
              </span>
            </li>
          </ul>
          <p className="home-contact__addr">
            มหาวิทยาลัยราชภัฏกำแพงเพชร 69 หมู่ 1 ต.นครชุม อ.เมือง จ.กำแพงเพชร
            62000
          </p>
        </div>
      </footer>
    </div>
  );
}

export default Home_newlastbee;
